


import { useEffect, useState } from "react";
import {
  FaArrowUp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import axios from "axios";
import { parse } from "tldts";
import "../css/Footer.css";

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [company, setCompany] = useState({
    name: "Your Bank",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
  });

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Quick links & socials
  const quickLinks = [
    { name: "About Us", url: "/about" },
    { name: "Team", url: "/teams" },
    // { name: "Contact Us", url: "/contact" },
    { name: "Contact Us", url: "/contact" },
  ];

  const communityLinks = [
    { name: "Documents", url: "/legal-documents" },
    { name: "Support ↗", url: "/support" },
    { name: "FAQs", url: "/faq" },
    { name: "Privacy Policy", url: "/privacy" },
    { name: "Terms & Conditions", url: "/terms" },
  ];

  const socials = [
    { icon: <FaFacebookF />, url: "#" },
    { icon: <FaInstagram />, url: "#" },
    { icon: <FaTwitter />, url: "#" },
    { icon: <FaLinkedinIn />, url: "#" },
    { icon: <FaYoutube />, url: "#" },
  ];

  // Parse domain info
  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  // Fetch company info
  useEffect(() => {
    const { domain } = getDomainInfo();
    const fetchCompany = async () => {
      try {
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;
        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
          }));
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };
    fetchCompany();
  }, []);

  const getImageUrl = (path) => {
    if (!path) return "";
    const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
    return `https://payyug.in/${cleanPath}`;
  };

  // Show scroll button
  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 250);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer className="techvision-landing-footer">
      <div className="techvision-landing-footer-animation"></div>

      <div className="techvision-landing-footer-container">
        {/* About */}
        <div className="techvision-landing-footer-about">
          {company.logo ? (
            <img
              src={getImageUrl(company.logo)}
              alt={company.name || "Logo"}
              className="techvision-landing-footer-logo"
            />
          ) : (
            <div className="techvision-landing-footer-fallback-logo">
              {company.name || "Logo"}
            </div>
          )}
          <p>
            Welcome to {company.name}, your trusted partner in finance. We
            provide solutions for loans with innovation
            and trust.
          </p>
        </div>

        {/* Quick Links */}
        <div className="techvision-landing-footer-links">
          <h3>Quick Links</h3>
          <ul>
            {quickLinks.map((link, idx) => (
              <li key={idx}>
                <a href={link.url}>{link.name}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Community */}
        <div className="techvision-landing-footer-links">
          <h3>Community</h3>
          <ul>
            {communityLinks.map((link, idx) => (
              <li key={idx}>
                <a href={link.url}>{link.name}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div className="techvision-landing-footer-social">
          <h3>Follow Us</h3>
          <div className="techvision-landing-footer-social-icons">
            {socials.map((s, idx) => (
              <a key={idx} href={s.url} target="_blank" rel="noreferrer">
                {s.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="techvision-landing-footer-bottom">
        <hr />
        <p>© {new Date().getFullYear()} {company.name || "raspaymfi"}. All rights reserved.</p>
        <p>Design & developed by <a href="https://visionpay.in/" className="ref-link">TechVision</a></p>
      </div>

      {/* Scroll to Top */}
      {showScroll && (
        <button
          className="techvision-landing-footer-scroll-top"
          onClick={scrollToTop}
        >
          <FaArrowUp />
        </button>
      )}
    </footer>
  );
};

export default Footer;
